export default [
  {
    name: 'number',
    label: {
      cs: 'Číslo',
      en: 'Number',
    },
    main: true,
    input: 'input',
    type: 'integer',
    min: 1,
    max: 99,
    required: true,
  },
  {
    name: 'group',
    label: {
      cs: 'Skupina',
      en: 'Group',
    },
    main: true,
    input: 'input',
    note: 'Optional',
    type: 'string',
    maxLength: 3,
  },
  {
    name: 'date',
    label: {
      cs: 'Datum',
      en: 'Date',
    },
    input: 'input',
    placeholder: 'DD.MM.YYYY',
    type: 'date',
    required: true,
  },
  {
    name: 'time',
    label: {
      cs: 'Čas',
      en: 'Time',
    },
    input: 'input',
    placeholder: 'HH:MM',
    type: 'time',
    required: true,
  },
  {
    name: 'visitor',
    label: {
      cs: 'Hosté ID',
      en: 'Visitor ID',
    },
    input: 'input',
    type: 'string',
    maxLength: 3,
    required: true,
  },
  {
    name: 'home',
    label: {
      cs: 'Domácí ID',
      en: 'Home ID',
    },
    input: 'input',
    type: 'string',
    maxLength: 3,
    required: true,
  },
  {
    name: 'field',
    label: {
      cs: 'Hřiště ID',
      en: 'Field ID',
    },
    input: 'input',
    type: 'integer',
    min: 1,
    max: 99,
    required: true,
  },
  {
    name: 'playByPlay',
    label: {
      cs: 'Play by play',
      en: 'Play by play',
    },
    input: 'input',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'stream',
    label: {
      cs: 'Stream',
      en: 'Stream',
    },
    input: 'input',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'czechTelevision',
    label: {
      cs: 'Česká televize',
      en: 'Czech television',
    },
    input: 'input',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'score.visitor',
    label: {
      cs: 'Skóre hosté',
      en: 'Score visitor',
    },
    input: 'input',
    note: 'Optional',
    type: 'integer',
    min: 0,
    max: 99,
  },
  {
    name: 'score.home',
    label: {
      cs: 'Skóre domácí',
      en: 'Score home',
    },
    input: 'input',
    note: 'Optional',
    type: 'integer',
    min: 0,
    max: 99,
  },
  {
    name: 'note.cs',
    label: {
      cs: 'Poznámka [CS]',
      en: 'Note [CS]',
    },
    input: 'input',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'note.en',
    label: {
      cs: 'Poznámka [EN]',
      en: 'Note [EN]',
    },
    input: 'input',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'wbscId',
    label: {
      cs: 'WBSC ID',
      en: 'WBSC ID',
    },
    input: 'input',
    note: 'Optional',
    type: 'integer',
    min: 1,
    max: 999999,
  },
];
